// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cut-word {
    display: inline-block;
    max-width: 24rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.open-temp span.text-center:hover {
    text-decoration: underline;
}

.open-temp span.text-center {
    color: #00aade;
    font-weight: 400;
}

.defaultPage {
    color: #adb5bd;
}

.publish-icon {
    color: #008fc7;
}

.unpublish-icon {
    color: darkgrey;
}

.unpublish-icon:hover,
.publish-icon:hover {
    color: #fff;
}

.sm-box {
    padding: 10px 15px 5px 15px;
    margin: 5px;
    border: 1px solid #e1e1e1;
    border-radius: 10px;
    box-shadow: 0px 0px 3px #d9d9d9;
    cursor: pointer;
}

.theme-scroll {
    height: 40vh !important;
}

button.btn.not-allowed:hover {
    cursor: not-allowed !important;
}

table.table-borderless {
    vertical-align: middle;
}


table.table-borderless tr td{
    background-color: rgba(0, 143, 199, 0);
    border-bottom: solid 1px rgba(0, 0, 0, 0.05);
    transition: background-color ease 1.5s;
}

/*table.table-borderless tr:hover td{
    background-color: rgba(0, 143, 199, 0.1);
}*/


.culture-pill{
    color: #008fc7;
    padding: 4px 4px 4px 13px;
    border-radius: 50px;
    font-weight: 600;
    margin-right: 0.5rem;
}

.culture-published{
    color: #008fc7;
}

.culture-unpublished{
    color: #adb5bd;
}


.submenu-container{
    position: absolute;
    display: none;
    top: 0;
    left: 100%;
    z-index: 1;
    width: 100%;
    background-color: #fff;
    border-radius: 6px;
    box-shadow: rgb(108 108 109 / 33%) 1px 2px 5px;
    overflow: hidden;
    padding: 1rem;
    min-width: 200px;

}

.submenu-container > ul{
    margin: 0px;
    padding: 0px;
}

.submenu-container > ul > li{
    list-style-type: none;
    background-color: rgba(25 ,25, 25, 0);
    transition: background-color ease 0.4s;
}

.submenu-container > ul > li:hover{
    list-style-type: none;
    background-color: rgba(25 ,25, 25, 0.1);
}

.submenu-container > ul > li:not(:last-child) {
    border-bottom: solid 1px rgba(25 ,25, 25, 0.1);
}

.submenu-container > ul > li > a{
    display: flex;
    align-items: center;
    text-align: start;
    padding: 2px 5px;
    min-height: 36px;
    font-size: 14px;
}

.dropdown:hover .submenu-container{
    display: block;
}`, "",{"version":3,"sources":["webpack://./src/app/views/pages/pages.component.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI,WAAW;AACf;;AAEA;IACI,2BAA2B;IAC3B,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,+BAA+B;IAC/B,eAAe;AACnB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;AAC1B;;;AAGA;IACI,sCAAsC;IACtC,4CAA4C;IAC5C,sCAAsC;AAC1C;;AAEA;;EAEE;;;AAGF;IACI,cAAc;IACd,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;;AAGA;IACI,kBAAkB;IAClB,aAAa;IACb,MAAM;IACN,UAAU;IACV,UAAU;IACV,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,8CAA8C;IAC9C,gBAAgB;IAChB,aAAa;IACb,gBAAgB;;AAEpB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,qCAAqC;IACrC,sCAAsC;AAC1C;;AAEA;IACI,qBAAqB;IACrB,uCAAuC;AAC3C;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB","sourcesContent":[".cut-word {\r\n    display: inline-block;\r\n    max-width: 24rem;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n}\r\n\r\n.open-temp span.text-center:hover {\r\n    text-decoration: underline;\r\n}\r\n\r\n.open-temp span.text-center {\r\n    color: #00aade;\r\n    font-weight: 400;\r\n}\r\n\r\n.defaultPage {\r\n    color: #adb5bd;\r\n}\r\n\r\n.publish-icon {\r\n    color: #008fc7;\r\n}\r\n\r\n.unpublish-icon {\r\n    color: darkgrey;\r\n}\r\n\r\n.unpublish-icon:hover,\r\n.publish-icon:hover {\r\n    color: #fff;\r\n}\r\n\r\n.sm-box {\r\n    padding: 10px 15px 5px 15px;\r\n    margin: 5px;\r\n    border: 1px solid #e1e1e1;\r\n    border-radius: 10px;\r\n    box-shadow: 0px 0px 3px #d9d9d9;\r\n    cursor: pointer;\r\n}\r\n\r\n.theme-scroll {\r\n    height: 40vh !important;\r\n}\r\n\r\nbutton.btn.not-allowed:hover {\r\n    cursor: not-allowed !important;\r\n}\r\n\r\ntable.table-borderless {\r\n    vertical-align: middle;\r\n}\r\n\r\n\r\ntable.table-borderless tr td{\r\n    background-color: rgba(0, 143, 199, 0);\r\n    border-bottom: solid 1px rgba(0, 0, 0, 0.05);\r\n    transition: background-color ease 1.5s;\r\n}\r\n\r\n/*table.table-borderless tr:hover td{\r\n    background-color: rgba(0, 143, 199, 0.1);\r\n}*/\r\n\r\n\r\n.culture-pill{\r\n    color: #008fc7;\r\n    padding: 4px 4px 4px 13px;\r\n    border-radius: 50px;\r\n    font-weight: 600;\r\n    margin-right: 0.5rem;\r\n}\r\n\r\n.culture-published{\r\n    color: #008fc7;\r\n}\r\n\r\n.culture-unpublished{\r\n    color: #adb5bd;\r\n}\r\n\r\n\r\n.submenu-container{\r\n    position: absolute;\r\n    display: none;\r\n    top: 0;\r\n    left: 100%;\r\n    z-index: 1;\r\n    width: 100%;\r\n    background-color: #fff;\r\n    border-radius: 6px;\r\n    box-shadow: rgb(108 108 109 / 33%) 1px 2px 5px;\r\n    overflow: hidden;\r\n    padding: 1rem;\r\n    min-width: 200px;\r\n\r\n}\r\n\r\n.submenu-container > ul{\r\n    margin: 0px;\r\n    padding: 0px;\r\n}\r\n\r\n.submenu-container > ul > li{\r\n    list-style-type: none;\r\n    background-color: rgba(25 ,25, 25, 0);\r\n    transition: background-color ease 0.4s;\r\n}\r\n\r\n.submenu-container > ul > li:hover{\r\n    list-style-type: none;\r\n    background-color: rgba(25 ,25, 25, 0.1);\r\n}\r\n\r\n.submenu-container > ul > li:not(:last-child) {\r\n    border-bottom: solid 1px rgba(25 ,25, 25, 0.1);\r\n}\r\n\r\n.submenu-container > ul > li > a{\r\n    display: flex;\r\n    align-items: center;\r\n    text-align: start;\r\n    padding: 2px 5px;\r\n    min-height: 36px;\r\n    font-size: 14px;\r\n}\r\n\r\n.dropdown:hover .submenu-container{\r\n    display: block;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
